import React from "react";
import { useI18n } from "@/i18n";
import { cn } from "@/lib/utils";

export default function LanguageSelector({ className = "", compact = false }) {
  const { language, setLanguage, t } = useI18n();
  return (
    <label className={cn("inline-flex items-center gap-2", className)}>
      <span className="sr-only">{t("language.label")}</span>
      <select
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        aria-label={t("language.label")}
        data-testid="language-selector"
        className={cn(
          "rounded-md border border-[var(--subtle)] bg-white px-2.5 py-1.5 text-xs font-semibold text-[var(--text-secondary)] shadow-sm focus:border-[var(--accent)] focus:outline-none focus:ring-2 focus:ring-[var(--accent)]/20",
          compact && "px-2 py-1",
        )}
      >
        <option value="en">{t("language.english")}</option>
        <option value="ar">{t("language.arabic")}</option>
      </select>
    </label>
  );
}
